export const GET_CALENDER_ITEMS =
  'src/modules/calender/GET_CALENDER_ITEMS';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/calender/CANCEL_ALL_API_REQUESTS';
